/**
 * Generated by orval v8.5.3 🍺
 * Do not edit manually.
 * Space Invoices API
 * REST API for invoice management, customer management, and accounting operations. Features include cursor-based pagination for efficient data navigation, flexible JSON querying with MongoDB-style operators, full-text search across multiple fields, and comprehensive metadata support for custom tracking.
 * OpenAPI spec version: 1.0.0
 */

/**
 * Canonical Slovenian legal form for the entity.
 * @nullable
 */
export type GetSloveniaTaxProfile200BusinessForm = typeof GetSloveniaTaxProfile200BusinessForm[keyof typeof GetSloveniaTaxProfile200BusinessForm] | null;


export const GetSloveniaTaxProfile200BusinessForm = {
  sp: 'sp',
  doo: 'doo',
  dno: 'dno',
  club: 'club',
} as const;
